'use client'

import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error for debugging
    console.error('App error caught:', error)
  }, [error])

  return (
    <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center px-4 py-8">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-bold text-white mb-4">
          Đã xảy ra lỗi!
        </h2>
        <p className="text-[#999] mb-6">
          Xin lỗi, đã có lỗi xảy ra. Vui lòng thử lại.
        </p>
        <div className="space-x-4">
          <button
            onClick={() => reset()}
            className="bg-[#0066cc] text-white px-6 py-2 rounded hover:bg-[#0052a3] transition-colors"
          >
            Thử lại
          </button>
          <button
            onClick={() => window.location.href = '/'}
            className="bg-[#333] text-white px-6 py-2 rounded hover:bg-[#444] transition-colors"
          >
            Về trang chủ
          </button>
        </div>
      </div>
    </div>
  )
} 